import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";
import {$agentFactory} from "../../$agent.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class AgentBranchesCtrl implements IController {

  agent: AgentModel;

  private agentRef: any;
  private canRemove: any;

  constructor(private $agent: $agentFactory, private IAMPermissions, private branchesDialogService: BranchesDialogService,
              private confirmDialogService: ConfirmDialogService, private agentsAlerts: AgentsAlerts, private $log, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.canRemove = this.IAMPermissions.hasPermission('drivers.update');
    this.agentRef = this.$agent(this.agent.id);
  };

  onAddBranches(event) {
    this.branchesDialogService.branchesSelect(event, this.agent.branchIds)
      .then((branchIds) => {
        const agentCopy = angular.copy(this.agent);

        if (!agentCopy.branchIds) {
          agentCopy.branchIds = [];
        }

        agentCopy.branchIds = agentCopy.branchIds.concat(branchIds);

        this.bringozLoaderService.on();
        return this.agentRef.$update(agentCopy);
      })
      .then((updatedAgent) => {
        this.agentsAlerts.addToBranchSuccess();
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.addToBranchError();
          this.$log.error('Failed to add branch to agent @agentBranches@onAddBranch', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onRemoveBranch(branchToRemove, event) {
    this.confirmDialogService.confirm('Remove Branch', 'Are you sure you want to remove this branch?', event)
      .then(() => {
        const agentCopy = angular.copy(this.agent);
        agentCopy.branchIds = _.without(this.agent.branchIds, branchToRemove.id);
        this.bringozLoaderService.on();
        return this.agentRef.$update(agentCopy);
      })
      .then((updatedAgent) => {
        this.agentsAlerts.removeFromBranchSuccess(updatedAgent);
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.removeFromBranchError();
          this.$log.error('Failed to remove branch from agent @agentBranches@onRemoveBranch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentBranches', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-branches.html').default,
    controller: AgentBranchesCtrl
  });
